import { render, staticRenderFns } from "./HomeShopByCategory.vue?vue&type=template&id=54b4d071&lang=pug&"
import script from "./HomeShopByCategory.vue?vue&type=script&lang=js&"
export * from "./HomeShopByCategory.vue?vue&type=script&lang=js&"
import style0 from "./HomeShopByCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b4d071')) {
      api.createRecord('54b4d071', component.options)
    } else {
      api.reload('54b4d071', component.options)
    }
    module.hot.accept("./HomeShopByCategory.vue?vue&type=template&id=54b4d071&lang=pug&", function () {
      api.rerender('54b4d071', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/home/HomeShopByCategory.vue"
export default component.exports